const matricula_errada = {
  path: "/matricula-errada",
  redirect: "/matricula-errada",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Matrículas",
  },
  children: [
    {
      path: "/matricula-errada",
      name: "matricula-errada",
      component: () => import("@/views/MatriculaErrada/MatriculaErrada.vue"),
    },
  ],
};
export { matricula_errada };
